import React, { useState } from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { View, Text, StyleSheet } from 'react-native';
import { SignupScreen } from 'fitbeat.gym-core';
import Theme, { ThemeType } from '../theme';
import { Switch } from '../ui/components/Switch';
import { getNextStep, navigateToNextStep } from './actions';
import { SelectionContainer } from '../Bookings/components/SelectionContainer';
import { defaultScale } from '../utils/scaling';
import { foodPreferences, UserDataConsumer } from '../utils';
import { GoogleAnalytics } from '../services/google-analytics';
import { getMealPlan } from '../Nutrition/actions';
import { sharedStyles } from './OnboardingSharedStyles';
import { enabledFeaturesSelector } from './auth-selectors';

function HomeNutrition({
  t,
  navigation,
  userProfile,
  getNextStep,
  navigateToNextStep,
  user: { userProfileService, nutritionService },
  enabledFeatures,
}) {
  const isHighlyActiveByDefault = !enabledFeatures.organisationConfig.nutritionConfig?.areUsersLessActiveByDefault;
  const [selectedNutritionPref, setselectedNutritionPref] = useState(null);
  const [isHighlyActive, setIsHighlyActive] = useState(isHighlyActiveByDefault);
  const [userHasAllergies, setUserHasAllergies] = useState(false);
  const setNutritionPrefAndNavigateToNextStep = (foodPref) => {
    const googleAnalytics = new GoogleAnalytics();
    setselectedNutritionPref(foodPref);
    getNextStep({
      getMealData: () => getMealPlan(nutritionService),
      userServiceClient: userProfileService,
      currentScreen: SignupScreen.Nutrition,
      userProfile: {
        mealPreferences: {
          foodPreference: foodPref,
          dietGoal: userProfile.longTermGoal,
        },
        isHighlyActive,
      },
      options: { userHasAllergies },
    });
    navigateToNextStep(navigation);
    googleAnalytics.logEventWithParamaters('sign_up_nutrition', { foodPreference: foodPref });
  };
  return (
    <View style={sharedStyles.container}>
      <Text
        style={[Theme.textStyle.heading, { marginBottom: defaultScale(6) }]}
      >
        {t('whatIsYourNutritionPref')}
      </Text>
      <Text
        style={[
          Theme.textStyle.bodyCopyReg,
          { color: Theme.GREY_MEDIUM, marginBottom: defaultScale(24) },
        ]}
      >
        {t('personalizeFitnessJourneyNutrition')}
      </Text>
      {foodPreferences.map((foodPref) => (
        <SelectionContainer
          title={foodPref.display}
          style={sharedStyles.selectionContainer}
          isSelected={selectedNutritionPref === foodPref.value}
          theme={ThemeType.light}
          onPress={() => {
            setNutritionPrefAndNavigateToNextStep(foodPref.value);
          }}
          height={defaultScale(100)}
          width='100%'
          titleStyle={sharedStyles.bookingSelectionTitle}
          subTitleStyle={sharedStyles.bookingSelectionSubtitle}
          overrideLightStyles={{ defaultSubtitleColor: Theme.GREY_MEDIUM }}
        />
      ))}
      <View style={styles.toggleContainer}>
        <Text style={{ ...Theme.textStyle.bodyCopyBold }}>{t('userHasAllergies')}</Text>
        <Switch
          trackColor={{ false: Theme.GREY_LIGHT, true: Theme.PRIMARY }}
          thumbColor={Theme.WHITE}
          ios_backgroundColor={Theme.GREY_LIGHT}
          onValueChange={(newValue) => setUserHasAllergies(newValue)}
          value={userHasAllergies}
        />
      </View>
      <View style={styles.toggleContainer}>
        <Text style={{ ...Theme.textStyle.bodyCopyBold }}>{t('hasActiveLifestyle')}</Text>
        <Switch
          trackColor={{ false: Theme.GREY_LIGHT, true: Theme.PRIMARY }}
          thumbColor={Theme.WHITE}
          ios_backgroundColor={Theme.GREY_LIGHT}
          onValueChange={setIsHighlyActive}
          value={isHighlyActive}
        />
      </View>
      <Text style={styles.toggleExplanationText}>{t('portionSizeforActiveLifestyle')}</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  toggleContainer: {
    justifyContent: 'space-between',
    alignItems: 'center',
    flexDirection: 'row',
    marginTop: defaultScale(40),
  },
  toggleExplanationText: {
    ...Theme.textStyle.bodyCopyReg,
    color: Theme.GREY_MEDIUM,
    maxWidth: defaultScale(270),
  },
});
const mapStateToProps = (state) => ({
  userProfile: state.auth.signup.userProfile,
  enabledFeatures: enabledFeaturesSelector(state),
});

const mapDispatchToProps = {
  getNextStep,
  navigateToNextStep,
  getMealPlan,
};

export const HomeNutritionScreen = translate(['auth'], { wait: true })(
  UserDataConsumer(connect(mapStateToProps, mapDispatchToProps)(HomeNutrition)),
);
